module.exports = __webpack_public_path__ + "static/media/skulls-small.71500bf4.gif";